import React from "react";
import { Row, Col, Divider } from "antd";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { Period } from "../../constants/Period";
const style = {
  textDecoration: "underline",
  padding: "0 12px 12px",
  cursor: "pointer",
};

const ReportLinks = (props) => {
  const getReduxDashboardSearchData = useSelector(
    ({ Reports }) => Reports.dashboardSearchData
  );
  const periodID = props && props.periodID ? props.periodID : Period.Day;
  const history = useHistory();
  function redirectToSalesReport(measureID, reportTypeID, reportID,reportName) {
    let fromFormatDate = moment().format("YYYY-MM-DDT00:00:00");
    let toFormatDate = moment().format("YYYY-MM-DDT23:59:00");
     
    if (periodID == Period.Month) {  
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD"); //subtract(6, 'months')
      fromFormatDate = moment(toFormatDate)
        .startOf("month")
        .format("YYYY-MM-DD");
    }
    // 32 : Week
    if (periodID == Period.Week) {
      toFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
      fromFormatDate = moment(toFormatDate)
        .startOf("isoWeek")
        .format("YYYY-MM-DD");
    }
    if (periodID == Period.Day) {
      toFormatDate = moment(toFormatDate)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
      fromFormatDate = moment(toFormatDate).format("YYYY-MM-DD");
    }
    let URL = "";
    
    URL = `/dashboard/reporting/${reportName}?definition={"ReportId":1,"ReportTypeId":${reportTypeID},"MeasureId":${measureID},"DateTimeFrom":"${fromFormatDate}","DateTimeTo":"${toFormatDate.toString()}","PeriodId":${periodID},"IsComparision":0,"ComparisionFrom":"","ComparisionTo":""}`;

    history.push(URL);
  }

  return (
    <>
      <h3 className="InventoryReports">{props.title}</h3>
      <Divider />
      <ul className="Dashboard-Footer-ul">
        {props.data &&
          props.data.map((obj, index) => {
            return (
              <li>
                <div onClick={() => redirectToSalesReport(obj.MeasureID, obj.ReportTypeID, obj.ReportID, obj.ReportName)}>
                  <IntlMessages id={obj.Name} />
                </div>
              </li>
            );
          })}
      </ul>
    </>
  );
};

export default ReportLinks;
